import type { UpdateCommentsDto } from '@getaccept/lib-shared/src/contextual-commenting/types/update-comments-dto';
import { CommentsMutations } from '@getaccept/lib-shared/src/contextual-commenting/graphql/comments.mutations';
import type { CommentEditorSelection } from '@getaccept/dsr-shared/src/contextual-commenting/types/comment-selection';
import { apolloClientInternal } from '@getaccept/lib-shared/src/internal/apollo-client-internal';

export class EditorCommentsService {
  static async updateMany(documentId: string, payload: UpdateCommentsDto): Promise<void> {
    await apolloClientInternal.mutate({
      mutation: CommentsMutations.updateMany,
      variables: {
        documentId,
        payload,
      },
    });
  }

  static async updateManyDealroomSelections(payload: {
    editorSelections: CommentEditorSelection[];
  }): Promise<void> {
    await apolloClientInternal.mutate({
      mutation: CommentsMutations.updateManyDealroomSelections,
      variables: {
        payload,
      },
    });
  }
}
